import React from 'react'

import './footer.css'

const Footer = (props) => {
  const year = new Date().getFullYear()
  return (
    <footer className="footer-section" data-testid="site-footer">
      <div className="footer-media-wrapper">
        <img
          alt=""
          aria-hidden="true"
          src="/gallery-4.jpg"
          className="footer-bg-image"
        />
        <div className="footer-overlay" />
      </div>
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-brand-lockup">
              <img
                src="/logo.png"
                alt="Leelanau Dock & Hoist"
                className="footer-brand-logo"
                data-testid="footer-logo"
              />
            </div>
            <p className="footer-description section-content">
              Family owned and operated out of Suttons Bay, Michigan by
              Ben Bakker. Dock installation, hoist sales, seasonal service,
              repair, and secure offsite storage across Leelanau County.
            </p>
            <div className="footer-contact-list">
              <a
                className="footer-contact-item"
                href="tel:+12314926114"
                data-testid="footer-phone-link"
              >
                <span className="footer-icon-box">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <span className="section-content">231-492-6114</span>
              </a>
              <a
                className="footer-contact-item"
                href="mailto:Ben45service@gmail.com"
                data-testid="footer-email-link"
              >
                <span className="footer-icon-box">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 6-10 7L2 6" />
                  </svg>
                </span>
                <span className="section-content">Ben45service@gmail.com</span>
              </a>
              <div className="footer-contact-item footer-contact-static">
                <span className="footer-icon-box">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <span className="section-content">
                  Suttons Bay, Leelanau County, MI
                </span>
              </div>
            </div>
          </div>
          <div className="footer-column">
            <h3 className="section-subtitle footer-heading">Explore</h3>
            <nav className="footer-nav">
              <ul className="footer-nav-list">
                <li className="footer-nav-item">
                  <a href="#about">
                    <div className="footer-link"><span>About</span></div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#services">
                    <div className="footer-link"><span>Services</span></div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#gallery">
                    <div className="footer-link"><span>Gallery</span></div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#service-area">
                    <div className="footer-link"><span>Service Area</span></div>
                  </a>
                </li>
                <li className="footer-nav-item">
                  <a href="#contact-form">
                    <div className="footer-link"><span>Request a Quote</span></div>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="footer-column">
            <h3 className="section-subtitle footer-heading">
              Ready for the season?
            </h3>
            <p className="footer-cta-text">
              The schedule fills up fast — especially in spring and late fall.
              Get a no-pressure quote and lock in your spot.
            </p>
            <a href="#contact-form" data-testid="footer-cta-quote">
              <div className="btn-lg btn btn-primary footer-cta-btn">
                <span>Request a Quote</span>
              </div>
            </a>
            <a
              href="tel:+12314926114"
              className="footer-cta-call"
              data-testid="footer-cta-call"
            >
              or call 231-492-6114
            </a>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/profile.php?id=61557339345224"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Leelanau Dock & Hoist on Facebook"
                className="footer-social-link"
                data-testid="footer-facebook-link"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                  className="footer-social-icon"
                >
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                </svg>
                <span>Follow on Facebook</span>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-legal">
            <p className="footer-copyright section-content">
              © {year} Leelanau Dock &amp; Hoist. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <span className="footer-legal-link">
                Locally owned · Suttons Bay, MI
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
